import { render, staticRenderFns } from "./ed-file-viewer.vue?vue&type=template&id=44cc0fd5&scoped=true&"
import script from "./ed-file-viewer.ts?vue&type=script&lang=js&"
export * from "./ed-file-viewer.ts?vue&type=script&lang=js&"
import style0 from "./ed-file-viewer.scss?vue&type=style&index=0&id=44cc0fd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc0fd5",
  null
  
)

export default component.exports